import { mutationTypes } from '@/types';
import { logger } from '@/tools';

import {
	batteryGetState,
	batteryGetLevel,
	appGetVersion,
	appGetIsLoaner,
	appIsIOS,
	appNeedsVolumeControl,
	infoGetDeviceName,
	infoGetModel,
	infoGetAPIVersion,
	infoGetBluetoothMAC,
	infoGetWifiMAC,
	infoGetOS,
	infoGetOSVersion,
} from '@/tools/nativeInterfaceFunctions';

export default store => {
	window.nativeOnAudioHeadphoneStateChanged = function(pluggedHeadphones) {
		logger.log('HeadPhoneStateCahenged is plugged ' + pluggedHeadphones);
		store.commit(mutationTypes.systemSetHeadPhoneState, { pluggedHeadphones });
	};

	/** Battery
	 * state : String “charging”, “full”, “discharging”, “unknown”
	 * **/
	window.nativeOnBatteryStateChanged = function(batteryState) {
		logger.log('nativeOnDeviceBatteryStateChanged: ' + batteryState);
		store.commit(mutationTypes.systemSetBatteryState, { batteryState });
	};

	store.subscribe(async mutation => {
		if (mutation.type === mutationTypes.nativeInterfaceUp) {
			const deviceInfo = {
				deviceName: await infoGetDeviceName(),
				deviceModel: await infoGetModel(),
				deviceOs: await infoGetOS(),
				deviceOsVersion: await infoGetOSVersion(),
				deviceBluetoothMac: await infoGetBluetoothMAC(),
				deviceWifiMac: await infoGetWifiMAC(),
			};
			store.commit(mutationTypes.systemSetDeviceInfo, { deviceInfo });

			const appInfo = {
				appIsLoaner: await appGetIsLoaner(),
				appIsIOS: await appIsIOS(),
				appApiVersion: await infoGetAPIVersion(),
				appVersion: await appGetVersion(),
				appNeedsVolumeControl: await appNeedsVolumeControl(),
			};
			store.commit(mutationTypes.systemSetAppInfo, { appInfo });
			store.commit(mutationTypes.systemSetBatteryState, {
				batteryState: await batteryGetState(),
			});
			store.commit(mutationTypes.systemSetBatteryLevel, {
				batteryLevel: await batteryGetLevel(),
			});
		}
	});
};
